export default "__VITE_ASSET__BAlyePLi__"